import React                             from 'react';
import { leadFreeProcessing as tooltip } from 'pu-data/Tooltips';
import RadioDualComponent                from './RadioDualComponent';

const LeadFreeProcessing = (props) => {
  const name = 'lead_free';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <RadioDualComponent
      name={name}
      label="Lead-Free Processing"
      tooltip={props.tooltip}
      onChange={onChange}
      parameters={props.parameters}
      className={props.className} />
  );
};

LeadFreeProcessing.defaultProps = {
  tooltip,
  className: 'lead-free-processing',
};

export default LeadFreeProcessing;
